// import i18n from '../../../../i18n';

// import DefinitionForm from '../../../DefinitionForm';

const FIELDS = [
  // No fields
];

export default () => FIELDS;
